import React from "react";
import { Routes, Route } from "react-router-dom";

import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => {
    return (
        <React.Fragment>
            <Routes>

                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={`public-${idx}`}
                    />
                ))}

                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <AuthProtected>
                                <VerticalLayout>
                                    {route.component}
                                </VerticalLayout>
                            </AuthProtected>
                        }
                        key={`protected-${idx}`}
                    />
                ))}

            </Routes>
        </React.Fragment>
    );
};

export default Index;